<template>
  <div class="px-10">
    <v-row no-gutters>
      <v-col>
        <v-icon medium>
          mdi-needle
        </v-icon>
        <span class="font-16 font-weight-bold mx-2">Covid-19 Vaccination</span>
        <employee-profile-vaccination-dialog-create
          v-if="isMyProfile || $hasPermissionTo(['upload employee vaccinations document'])"
          :employee-uid="employeeUid"
          @created="loadEmployeeVaccinations"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col
        v-if="vaccinations.length > 0"
        cols="12"
      >
        <div
          v-for="vaccination in vaccinations"
          :key="vaccination.id"
        >
          <div v-if="['png','jpeg','jpg'].includes(vaccination.file_path.split('.').pop().toLowerCase())">
            <v-icon color="blue">
              mdi-image
            </v-icon>
            <v-btn
              text
              :href="vaccination.file_url"
              target="_blank"
            >
              {{ vaccination.file_name }}
            </v-btn>
          </div>
          
          <div v-else>
            <v-icon color="red">
              mdi-file-pdf-box
            </v-icon>
            <v-btn
              text
              :href="vaccination.file_url"
              target="_blank"
            >
              {{ vaccination.file_name }}
            </v-btn>
          </div>
        </div>
      </v-col>

      <v-col
        v-else
        cols="12"
      >
        No data available
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileVaccinationDialogCreate: () => import('@/components/hris/employee/profile/vaccination/DialogCreate'),
    },
    props: {
      employeeUid: {
        type: String,
        default: '',
      },
    },
    data () {
      return {
        loading: false,
        vaccinations: [],
      }
    },
    computed: {  
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (value) {
          if (value) {
            this.loadEmployeeVaccinations()
          }
        },
      },
    },
    methods: {    
      loadEmployeeVaccinations () {
        this.loading = true

        this.$api.employeeVaccinations().list(this.employeeUid)
          .then(response => {       
            this.vaccinations = response.data     
          })
          .catch(() => {})
          .then(() => {
            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-16{
  font-size:16px;
}
</style>
